import { FC } from 'react'
import {
	RNCarriers,
	RNProfile,
	RNLogin,
	RNLogout,
	RNCarrierGroups,
	RNLogging,
	RNLoggingCodes,
	RNUsers,
	RNSensors,
	RNBalance,
	RNWelcome,
	RNCarrierSelect,
	RNSuccess,
	RNRegister,
	RNCommon,
	RNUpdatesDashboard,
	RNUpdatesMachines,
	RNUpdatesVersions,
	RNUpdatesDeploy,
	RNUpdatesCarrierTypes,
	RNInventoryEquipment,
	RNInventoryInstallations,
	RNInventoryInspections
} from './helpers/routeNames'
import Test from './pages/Test'
import Login from './pages/Login'
import Users from './pages/Users'
import Logout from './pages/Logout'
import UserOne from './pages/UserOne'
import Carrier from './pages/Carrier'
import CarrierOne from './pages/CarrierOne'
import CarrierEdit from './pages/CarrierEdit'
import CarrierAdd from './pages/CarrierAdd'
import UserAdd from './pages/UserAdd'
import Sensors from './pages/Sensor'
// import SensorOne from './pages/SensorOne'
import SensorAdd from './pages/SensorAdd'
import SensorEdit from './pages/SensorEdit'
import Profile from './pages/Profile'
import Balance from './pages/Balance'
import BalanceOne from './pages/BalanceOne'
import Welcome from './pages/Welcome'
import CarrierSelect from './pages/CarrierSelect'
import RegisterRequest from './pages/RegisterRequest'
import RegisterRequestAsk from './pages/RegisterRequestAsk'
import { Common } from './pages/e-railway/Common'
import Logging from './pages/Logging'
import LoggingAll from './pages/LoggingAll'
import LoggingCodes from './pages/LoggingCodes'
import UpdatesDashboard from './pages/UpdatesDashboard'
import UpdatesMachines from './pages/UpdatesMachines'
import UpdatesVersions from './pages/UpdatesVersions'
import UpdatesDeploy from './pages/UpdatesDeploy'
import UpdatesCarrierTypes from './pages/UpdatesCarrierTypes'
import InventoryEquipment from './pages/InventoryEquipment'
import InventoryInstallations from './pages/InventoryInstallations'
import InventoryInspections from './pages/InventoryInspections'

export interface IElementProps {
	sideBarShown: boolean
	carrierId?: number
}

interface Route {
	path: string
	Element: FC<IElementProps>
}

export const Routes: Route[] = [
	{
		path: RNWelcome,
		Element: Welcome
	},
	{
		path: RNCarriers,
		Element: Carrier
	},
	{
		path: RNCarriers + '/:id',
		Element: CarrierOne
	},
	{
		path: RNCarriers + '/new',
		Element: CarrierAdd
	},
	{
		path: RNCarriers + '/edit/:id',
		Element: CarrierEdit
	},
	{
		path: RNCarrierGroups,
		Element: Test
	},
	{
		path: RNCarrierGroups + '/:id',
		Element: Test
	},
	{
		path: RNSensors,
		Element: Sensors
	},
	{
		path: RNBalance,
		Element: Balance
	},
	{
		path: RNBalance + '/:id',
		Element: BalanceOne
	},
	{
		path: RNSensors + '/:id',
		Element: SensorEdit //SensorOne
	},
	{
		path: RNSensors + '/new',
		Element: SensorAdd
	},
	{
		path: RNSensors + '/edit/:id',
		Element: SensorEdit
	},
	{
		path: RNLogging,
		Element: LoggingAll
	},
	{
		path: RNLogging + '/:id',
		Element: Logging
	},
	{
		path: RNLoggingCodes,
		Element: LoggingCodes
	},
	{
		path: RNUsers,
		Element: Users
	},
	{
		path: RNUsers + '/:id',
		Element: UserOne
	},
	{
		path: RNUsers + '/new',
		Element: UserAdd
	},
	{
		path: RNUsers + '/edit/:id',
		Element: UserOne
	},
	{
		path: RNProfile,
		Element: Profile
	},
	{
		path: RNCarrierSelect,
		Element: CarrierSelect
	},
	{
		path: RNSuccess + RNRegister,
		Element: RegisterRequest
	},
	{
		path: RNSuccess + RNRegister + '/ask',
		Element: RegisterRequestAsk
	},
	{
		path: RNCommon + '/:id',
		Element: Common
	},
	{
		path: RNUpdatesDashboard,
		Element: UpdatesDashboard
	},
	{
		path: RNUpdatesMachines,
		Element: UpdatesMachines
	},
	{
		path: RNUpdatesVersions,
		Element: UpdatesVersions
	},
	{
		path: RNUpdatesDeploy,
		Element: UpdatesDeploy
	},
	{
		path: RNUpdatesCarrierTypes,
		Element: UpdatesCarrierTypes
	},
	{
		path: RNInventoryEquipment,
		Element: InventoryEquipment
	},
	{
		path: RNInventoryInstallations,
		Element: InventoryInstallations
	},
	{
		path: RNInventoryInspections,
		Element: InventoryInspections
	},
	{
		path: '*',
		Element: Test
	},
	{
		path: RNLogout,
		Element: Logout
	}
]

export const loginRoutes: Route[] = [
	{
		path: RNLogin,
		Element: Login
	},
	{
		path: RNCommon + '/:id',
		Element: Common
	},
	{
		path: '*',
		Element: Test
	}
]
